import { CloseSquare } from "iconsax-react";
import { useEffect, useState } from "react";
import { getToken } from "../../../utils/token";
import NormalInputField from "../../inputs/NormalInputField";
import PrimaryAddButton from "../../buttons/PrimaryAddButton";
import instance from "../../../axios/instance";
import { toast } from "react-toastify";
import NormalSelectInputField from "../../inputs/NormalSelectInputField";

export default function AddNewDoctor(props) {
  const token = getToken();
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState("");
  const [specialty, setSpecialty] = useState("");
  const [firstName, setFirstName] = useState("");

  const isButtonNotActive = !email || !firstName || !specialty;

  const handleCreateFacility = (e) => {
    e.preventDefault();
    setIsLoading(true);
    instance
      .post(
        "/doctor/doctors/new",
        {
          email,
          firstname: firstName,
          specialty,
          type: "member"
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        toast.success("New member added");
        setSuccess(true);
        props.triggerRevalidate();
        props.onClose();
      })
      .catch((error) => {
        setSuccess(false);
        toast.error(error?.response?.data?.message, { autoClose: false });
        setIsLoading(false);
      });
  };

  const closeModal = () => {
    setSuccess(false);
    props.onClose();
  };

  return (
    <>
      <div
        className={`${
          props.isOpen ? "block" : "hidden"
        } fixed min-w-[400px] top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-40 bg-white overflow-y-scroll scrollbar-hide rounded-md`}
      >
        <div className="sticky left-0 right-0 top-0">
          <div className="bg-[#f1f1f1] px-5 py-4 flex justify-between">
            <div>
              <div className="text-[18px] font-bold select-none">
                {success ? "Added" : "Add"} Member
              </div>
            </div>
            <button onClick={closeModal}>
              <CloseSquare variant="Bold" />
            </button>
          </div>

          <span className="block text-sm px-5 my-4">
            An invite link will be sent to the email provided.
          </span>
        </div>

        {success ? (
          <span className="block text-sm px-5 py-4">
            An invite link has been sent to the email to complete the sign up
            process
          </span>
        ) : (
          <form
            onSubmit={handleCreateFacility}
            className="px-5 py-3 text-[14px] space-y-4 mt-4"
          >
            <NormalInputField
              title="First Name"
              isRequired={true}
              type="text"
              onChange={(e) => setFirstName(e.target.value)}
            />
            <NormalInputField
              title="Email"
              isRequired={true}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
            />
            <NormalSelectInputField
              title="Specialty"
              values={[
                { value: "doctor", label: "Doctor" },
                { value: "nurse", label: "Nurse" },
                { value: "worker", label: "Worker" },
              ]}
              isRequired={true}
              onChange={(e) => setSpecialty(e.target.value)}
            />
            <div className="mt-4">
              <PrimaryAddButton
                title="Add Member"
                isLoading={isLoading}
                disabled={isButtonNotActive || isLoading}
                color="white"
                type="submit"
              />
            </div>
          </form>
        )}
      </div>
      {props.isOpen && (
        <div
          className="fixed z-20 inset-0 bg-[rgba(0,0,0,.2)]"
          onClick={closeModal}
        />
      )}
    </>
  );
}
